<template>
  <v-container grid-list-xl fluid text-xs-center pa-0 mb-3>
    <v-layout row xs12 wrap>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-layout align-center row fill-height>
              <v-flex
                xs4
                v-if="
                  $keycloak.hasResourceRole('admin', 'aloha-admin-app') ||
                  $keycloak.hasResourceRole('direction', 'aloha-admin-app') ||
                  $keycloak.hasResourceRole(
                    'centre-formation-base',
                    'aloha-admin-app'
                  )
                "
              >
                <v-select
                  :items="params.departements"
                  label="Département"
                  v-model="selectedFilters.departement"
                  color="teal"
                ></v-select>
              </v-flex>
              <v-flex
                xs4
                v-if="$keycloak.hasResourceRole('doyen', 'aloha-admin-app')"
              >
                <v-select
                  :items="params.filieres"
                  label="Filière"
                  v-model="selectedFilters.filiere"
                  color="teal"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-select
                  :items="params.modes"
                  label="Mode de déploiement"
                  v-model="selectedFilters.mode"
                  color="teal"
                ></v-select>
              </v-flex>
              <v-flex xs4>
                <v-btn @click="resetFilters" ma-0 flat
                  >Réinitialiser les filtres</v-btn
                >
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: ['params', 'filterStudents'],
  async mounted() {
    this.loading = true;
    try {
      const response = await this.fetchRemainingTests();
      this.oxfordPlacementTest.remaining = response.remaining;
    } catch (error) {
      this.error = 'Unable to fetch remaining placement tests';
    } finally {
      this.loading = false;
    }
  },
  data: () => ({
    loading: false,
    error: null,
    selectedFilters: {
      departement: undefined,
      mode: undefined,
    },
    oxfordPlacementTest: {
      remaining: 0,
    },
  }),
  computed: {
    getCardColor() {
      const remaining = this.oxfordPlacementTest.remaining;

      if (remaining === undefined || remaining === null) {
        return 'grey lighten-3';
      } else if (remaining >= 50) {
        return 'green lighten-5';
      } else if (remaining >= 10) {
        return 'orange lighten-5';
      } else {
        return 'red lighten-5';
      }
    },
  },
  methods: {
    resetFilters: function () {
      this.selectedFilters = {
        departement: undefined,
        mode: undefined,
        filiere: undefined,
      };
    },
  },
  watch: {
    selectedFilters: {
      handler: function (selectedFilters) {
        this.filterStudents(selectedFilters);
      },
      deep: true,
    },
  },
};
</script>
